module.exports = __webpack_public_path__ + "static/media/hatchback.e10f9012.svg";